<template>
  <div class="payment-list">
    <el-container>
      <el-header>
        <el-form :model="queryFormData" :inline="true">
          <el-row>
            <el-col :span="6">
              <el-form-item label="项目部" label-width="80px">
                <el-select
                  v-model="queryFormData.deptId"
                  placeholder="请选择..."
                  clearable
                  @change="deptIdChange"
                >
                  <el-option
                    v-for="dept in deptList"
                    :key="dept.deptId"
                    :label="dept.deptName"
                    :value="dept.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目名称" label-width="80px">
                <!-- projectId -->
                <el-select
                  v-model="queryFormData.projectId"
                  placeholder="请选择..."
                  clearable
                >
                  <el-option
                    v-for="project in projectList"
                    :key="project.projectId"
                    :label="project.projectName"
                    :value="project.projectId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="付款明细开始日期" label-width="120px">
                <el-date-picker
                  v-model="queryFormData.payDetailDateStart"
                  type="month"
                  placeholder="请选择"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="付款明细结束日期" label-width="120px">
                  <el-date-picker
                    v-model="queryFormData.payDetailDateEnd"
                    type="month"
                    placeholder="请选择"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter?24:6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="searchData">查询</el-button>
                <el-button type="info" icon @click="resetSearch">重置</el-button>
                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div class="handlePanel">
          <!-- <el-button type="primary" @click="searchData">查询</el-button>
          <el-button type="primary" @click="resetSearch">重置</el-button> -->
          <el-button type="primary" v-if="btnAuthorize.addBtn.btnEnable" icon="el-icon-plus" @click="createItem"
            >新建</el-button
          >
          <el-button type="primary" v-if="btnAuthorize.modifyBtn.btnEnable" icon="el-icon-edit" @click="editItem"
            >修改</el-button
          >
          <el-button type="primary" v-if="btnAuthorize.delBtn.btnEnable" icon="el-icon-delete" @click="deleteItems"
            >删除</el-button
          >
          <el-button type="primary" v-if="btnAuthorize.export.btnEnable" icon="el-icon-download" @click="exportData"
            >导出</el-button
          >
        </div>
      </el-header>
      <el-main>
        <el-table
          ref="dataTable"
          :data="tableData"
          highlight-current-row
          size="mini"
          height="100%"
          border
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
          @row-dblclick="handleRowDbClick"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column
            prop="deptName"
            label="项目部"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="projectName"
            label="项目名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="本次审批付款额" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ formatMoneyNumber(scope.row.auditAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payDetailDate"
            label="付款明细日期"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="operatorName"
            label="操作用户"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="操作日期"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
/**
 * 付款明细列表
 */
import Constants from "@/utils/consts";
import {
  getProjectList,
  getPaymentList,
  deletePayment,
  getPayDetailListDept,
  payDetailExportApi,
  payDetailListProjectApi
} from "../../services/financeService";
import { formatMoney } from "./utils";
export default {
  name: "PaymentList",
  data() {
    return {
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false },
        export: { key: "export", btnEnable: false } // 导出
      },
      pageIndex: 1,
      pageSize: 20,
      queryFormData: {
        deptId: undefined,
        payDetailDateStart: "",
        payDetailDateEnd: "",
        projectId: undefined,
        projectName: undefined
      },
      total: 0,
      tableData: [],
      deptList: [], // 可供选择的项目部
      projectList: [],
      selectedItems: [],
      showAdvanceFilter: false,
    };
  },
  methods: {
    formatMoneyNumber: formatMoney,
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getDeptListForSelect();
      this.getTableList();
    },
    /**
     * 获取供选择的项目部列表
     * 查询： 项目部下拉用付款明细这边这个接口，得到id后，调合同的根据项目部获取项目列表的接口
     */
    getDeptListForSelect() {
      getPayDetailListDept()
        .then(res => {
          if (res.code == 10000000) {
            this.deptList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message, "提示");
        });
    },
    /**
     * 选择的项目部id变了，重新获取可以选择的项目列表
     */
    deptIdChange(value) {
      if (value) {
        this.queryFormData.projectId = undefined;
        this.queryFormData.projectName = undefined;
        this.getProjectListForSelect();
      } else {
        this.projectList = [];
      }
    },
    getProjectListForSelect() {
      // getProjectList

      payDetailListProjectApi({ deptId: this.queryFormData.deptId })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.projectList = res.data || [];
            console.log("--供选择的项目列表", this.projectList);
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    searchData() {
      this.getTableList();
    },
    resetSearch() {
      this.queryFormData = {
        deptId: undefined,
        payDetailDateStart: "",
        payDetailDateEnd: "",
        projectId: undefined,
        projectName: undefined
      };
      this.projectList = [];
      this.getTableList();
    },
    formatQueryDate(date) {
      if (!date) {
        return undefined;
      }
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return year + "-" + (month < 10 ? "0" + month : month);
    },
    /**
     * 获取列表数据
     */
    getTableList() {
      getPaymentList({
        deptId: this.queryFormData.deptId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        payDetailDateStart: this.formatQueryDate(
          this.queryFormData.payDetailDateStart
        ),
        payDetailDateEnd: this.formatQueryDate(
          this.queryFormData.payDetailDateEnd
        ),
        projectId: this.queryFormData.projectId,
        projectName: this.queryFormData.projectName
      })
        .then(res => {
          if (res.code == 10000000) {
            this.tableData = res.data || [];
            this.total = res.total;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message, "提示");
        });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.getTableList();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.getTableList();
    },
    /**
     * 新建付款明细
     */
    createItem() {
      this.bus.$emit("navMenuChange", {
        routeId: "createPayment"
      });
    },
    /**
     * 修改付款明细
     */
    editItem() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要修改的目标数据", "提示");
        return;
      }
      if (this.selectedItems.length > 1) {
        this.$alert("只能修改单条数据", "提示");
        return;
      }
      let target = this.selectedItems[0];
      this.bus.$emit("navMenuChange", {
        routeId: "editPayment",
        routeParam: {
          id: target.id
        }
      });
    },
    /**
     * 删除付款明细
     */
    deleteItems() {
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要删除的数据", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      this.$confirm("您确定要删除选定的数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = [];
          for (let i = 0; i < this.selectedItems.length; i++) {
            ids.push(this.selectedItems[i].id);
          }
          return deletePayment({ delIds: ids });
        })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.getTableList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          if (error instanceof Error) {
            this.$alert(error.message, "提示");
          }
        });
    },
    exportData() {
      // 导出付款明细
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请选择要导出的数据", "提示");
        return;
      }
      let ids = this.selectedItems.map(item => item.id);
      payDetailExportApi({
        exportIds: ids
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            console.log("=======", res.data);
            let url = res.data;
            const a = document.createElement("a");
            a.href = url;
            a.download = "付款明细";
            a.click();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert("操作失败", "提示");
        });
    },
    handleSelectionChange(val) {
      // 选择/不选择某条
      this.selectedItems = val || [];
    },
    handleRowClick(row, column) {
      // 单击某行
      if (!this.selectedItems) {
        this.selectedItems = [row];
      } else {
        let index = this.selectedItems.indexOf(row);
        if (index != -1) {
          this.selectedItems.splice(index, 1);
        } else {
          this.selectedItems.push(row);
        }
      }
      this.$refs["dataTable"].toggleRowSelection(row);
    },
    /**
     * 某一行数据被双击，就是查看详情
     */
    handleRowDbClick(row, column) {
      this.bus.$emit("navMenuChange", {
        routeId: "paymentDetail",
        routeParam: {
          id: row.id
        }
      });
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.payment-list {
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
}

.handlePanel {
  text-align: right;
  margin-top: 16px;
}
</style>
